__turbopack_context__.v({
  "className": "itclubalingraphfont_be7aeba7-module__Rcez8W__className",
  "variable": "itclubalingraphfont_be7aeba7-module__Rcez8W__variable",
});
